import '@/styles/main.scss'

import Vue from 'vue'
import VueSocialSharing from 'vue-social-sharing'

import { initializeApp, initializeFirestore } from '@/service/firebase'

import App from './App.vue'

import './registerServiceWorker'
import router from './router'
import { store } from './store'
import i18n from './i18n'

Vue.use( VueSocialSharing )
Vue.config.productionTip = false

initializeFirestore().catch( error => console.error( error ) )

new Vue( {
  router,
  store,
  i18n,
  render: h => h( App )
} ).$mount( '#oubey-explorer' )
